import type { TokenStore } from "../api";

/**
 * Session token in the platform secure store: Android Keystore-backed encrypted storage / iOS Keychain
 * (@aparajita/capacitor-secure-storage). Cached in memory after the first read.
 */
const KEY = "session";
let cache: string | null | undefined;
export const secureTokenStore: TokenStore = {
  async get() {
    if (cache !== undefined) return cache;
    const { SecureStorage } = await import("@aparajita/capacitor-secure-storage");
    try { const v = await SecureStorage.get(KEY); cache = typeof v === "string" ? v : null; } catch { cache = null; }
    return cache;
  },
  async set(token) {
    const { SecureStorage } = await import("@aparajita/capacitor-secure-storage");
    cache = token;
    if (token) await SecureStorage.set(KEY, token); else await SecureStorage.remove(KEY).catch(() => undefined);
  },
};
export async function initSecureStore() {
  const { SecureStorage } = await import("@aparajita/capacitor-secure-storage");
  await SecureStorage.setKeyPrefix("spos_");
}
